 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtime-app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime-app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"components/spiner/spiner":"components/spiner/spiner","locale/locale-en-js":"locale/locale-en-js","locale/locale-ka-js":"locale/locale-ka-js","page/home":"page/home","page/layout/layout-home":"page/layout/layout-home","page/layout/layout-main":"page/layout/layout-main","page/main/nested/economicIndicator/main-economicIndicator":"page/main/nested/economicIndicator/main-economicIndicator","page/main/nested/economicIndicator/nested/dynamic-page":"page/main/nested/economicIndicator/nested/dynamic-page","vendor/amcharts/amcharts-core":"vendor/amcharts/amcharts-core","vendors~components/main/economicIndicator/data-table~components/main/economicIndicator/highchart~com~6693ae68":"vendors~components/main/economicIndicator/data-table~components/main/economicIndicator/highchart~com~6693ae68","page/Highchart":"page/Highchart","components/home/category":"components/home/category","layout/partial/footer":"layout/partial/footer","layout/partial/nav-bar":"layout/partial/nav-bar","components/main/economicIndicator/data-table-filter":"components/main/economicIndicator/data-table-filter","components/main/economicIndicator/step-category-menu":"components/main/economicIndicator/step-category-menu","components/r-slider/excel":"components/r-slider/excel","components/scope-modal/scope-and-fitch":"components/scope-modal/scope-and-fitch","components/static/GlobalCompettiveness":"components/static/GlobalCompettiveness","components/static/HumanDevelopmentIndex":"components/static/HumanDevelopmentIndex","components/static/StartingBusiness":"components/static/StartingBusiness","components/main/economicIndicator/data-table":"components/main/economicIndicator/data-table","components/main/economicIndicator/highchart":"components/main/economicIndicator/highchart","components/main/economicIndicator/world-map":"components/main/economicIndicator/world-map","components/r-slider/r-slider":"components/r-slider/r-slider"}[chunkId]||chunkId) + "." + {"components/spiner/spiner":"a4d040da","locale/locale-en-js":"83875dc4","locale/locale-ka-js":"6cf6facc","page/home":"7113d888","page/layout/layout-home":"233c556e","page/layout/layout-main":"db3494fe","page/main/nested/economicIndicator/main-economicIndicator":"aa1f879c","page/main/nested/economicIndicator/nested/dynamic-page":"4c55b478","vendor/amcharts/amcharts-core":"50492a68","vendors~components/main/economicIndicator/data-table~components/main/economicIndicator/highchart~com~6693ae68":"80da67e5","page/Highchart":"a2bc80c8","components/home/category":"c252ed0f","layout/partial/footer":"bb8a4503","layout/partial/nav-bar":"5b81fe43","components/main/economicIndicator/data-table-filter":"b3c949b3","components/main/economicIndicator/step-category-menu":"bacd981d","components/r-slider/excel":"a425ae03","components/scope-modal/scope-and-fitch":"182a5755","components/static/GlobalCompettiveness":"eace2d40","components/static/HumanDevelopmentIndex":"40c8ece6","components/static/StartingBusiness":"b5192160","components/main/economicIndicator/data-table":"d7539245","components/main/economicIndicator/highchart":"2d0f2fc9","components/main/economicIndicator/world-map":"7eecc80f","components/r-slider/r-slider":"a8c14ac3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"components/spiner/spiner":1,"page/home":1,"page/main/nested/economicIndicator/main-economicIndicator":1,"page/main/nested/economicIndicator/nested/dynamic-page":1,"page/Highchart":1,"components/home/category":1,"layout/partial/nav-bar":1,"components/main/economicIndicator/data-table-filter":1,"components/main/economicIndicator/step-category-menu":1,"components/r-slider/excel":1,"components/static/GlobalCompettiveness":1,"components/static/HumanDevelopmentIndex":1,"components/static/StartingBusiness":1,"components/main/economicIndicator/data-table":1,"components/main/economicIndicator/highchart":1,"components/main/economicIndicator/world-map":1,"components/r-slider/r-slider":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"components/spiner/spiner":"components/spiner/spiner","locale/locale-en-js":"locale/locale-en-js","locale/locale-ka-js":"locale/locale-ka-js","page/home":"page/home","page/layout/layout-home":"page/layout/layout-home","page/layout/layout-main":"page/layout/layout-main","page/main/nested/economicIndicator/main-economicIndicator":"page/main/nested/economicIndicator/main-economicIndicator","page/main/nested/economicIndicator/nested/dynamic-page":"page/main/nested/economicIndicator/nested/dynamic-page","vendor/amcharts/amcharts-core":"vendor/amcharts/amcharts-core","vendors~components/main/economicIndicator/data-table~components/main/economicIndicator/highchart~com~6693ae68":"vendors~components/main/economicIndicator/data-table~components/main/economicIndicator/highchart~com~6693ae68","page/Highchart":"page/Highchart","components/home/category":"components/home/category","layout/partial/footer":"layout/partial/footer","layout/partial/nav-bar":"layout/partial/nav-bar","components/main/economicIndicator/data-table-filter":"components/main/economicIndicator/data-table-filter","components/main/economicIndicator/step-category-menu":"components/main/economicIndicator/step-category-menu","components/r-slider/excel":"components/r-slider/excel","components/scope-modal/scope-and-fitch":"components/scope-modal/scope-and-fitch","components/static/GlobalCompettiveness":"components/static/GlobalCompettiveness","components/static/HumanDevelopmentIndex":"components/static/HumanDevelopmentIndex","components/static/StartingBusiness":"components/static/StartingBusiness","components/main/economicIndicator/data-table":"components/main/economicIndicator/data-table","components/main/economicIndicator/highchart":"components/main/economicIndicator/highchart","components/main/economicIndicator/world-map":"components/main/economicIndicator/world-map","components/r-slider/r-slider":"components/r-slider/r-slider"}[chunkId]||chunkId) + "." + {"components/spiner/spiner":"a01cf470","locale/locale-en-js":"31d6cfe0","locale/locale-ka-js":"31d6cfe0","page/home":"88892794","page/layout/layout-home":"31d6cfe0","page/layout/layout-main":"31d6cfe0","page/main/nested/economicIndicator/main-economicIndicator":"1453399f","page/main/nested/economicIndicator/nested/dynamic-page":"59f14cd3","vendor/amcharts/amcharts-core":"31d6cfe0","vendors~components/main/economicIndicator/data-table~components/main/economicIndicator/highchart~com~6693ae68":"31d6cfe0","page/Highchart":"425ec4c7","components/home/category":"7943ec63","layout/partial/footer":"31d6cfe0","layout/partial/nav-bar":"b45459bb","components/main/economicIndicator/data-table-filter":"1e3e690a","components/main/economicIndicator/step-category-menu":"e14498c3","components/r-slider/excel":"b5651812","components/scope-modal/scope-and-fitch":"31d6cfe0","components/static/GlobalCompettiveness":"56c3ed81","components/static/HumanDevelopmentIndex":"c28fd37a","components/static/StartingBusiness":"0c483638","components/main/economicIndicator/data-table":"56e0ed56","components/main/economicIndicator/highchart":"ba0bfa3d","components/main/economicIndicator/world-map":"fb1fba6f","components/r-slider/r-slider":"317f484b"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
